/**
 * Created by Bart Decorte
 * Date: 14/05/2020
 * Time: 19:45
 */
import EpochFilter from './EpochFilter';

export default class TimeFilter extends EpochFilter {
  constructor($root) {
    const params = {};
    params.format = 'H:i:S'
    params.enableTime = true;
    params.noCalendar = true;
    super($root, params);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/TimeFilter.js